import { useEffect } from "react";
import { STANDARDS_SET_MODE } from "@/search/Langston/types/IStandardsSetMode";
import { titleAndSubtitleContainer } from "@/search/Langston/FilterPanel/filters/Standards/StandardsModal/shared/shared.styles";
import { useStandardsSearchContext } from "@/search/Langston/StandardsSearchProvider";
import { useStandardsModalContext } from "../../../StandardsModalProvider";
import { StandardsModalSearchInput } from "..";
import { StandardsSetsDropdownFilter } from "./StandardsSetsDropdownFilter";
import {
  inputGroupCss,
  rootCss,
  rootViewOrCreateModeCss,
  subtitleCss,
  titleCss,
  headingRootCss,
} from "./StandardsSetsHeader.styles";

// TODO: Change the name of this.
export const StandardsSetsHeader = () => {
  const {
    getters: {
      selectedSubjectFilter,
      selectedDateFilter,
      availableDates,
      availableSubjects,
      standardsSetMode,
      needle,
    },
    handlers: { setSelectedSubjectFilter, setSelectedDateFilter, setNeedle },
  } = useStandardsModalContext();

  const renderTitleAndSubtitle = () => {
    if (standardsSetMode === STANDARDS_SET_MODE.CREATE) {
      return (
        <div css={[titleAndSubtitleContainer, headingRootCss]}>
          <p css={titleCss}>Create a custom standards set</p>
          <span css={subtitleCss}>
            Find standards to add to your custom set
          </span>
        </div>
      );
    } else if (
      standardsSetMode === STANDARDS_SET_MODE.VIEW ||
      standardsSetMode === STANDARDS_SET_MODE.DELETE
    ) {
      return (
        <div css={[titleAndSubtitleContainer, headingRootCss]}>
          <p css={titleCss}>Discover the standards you need</p>
          <span css={subtitleCss}>
            Look for standards utilizing the search and filters
          </span>
        </div>
      );
    }

    return null;
  };

  const { handleStandardsSearch, isLoadingStandardsResults } =
    useStandardsSearchContext();

  useEffect(() => {
    const handler = setTimeout(() => {
      handleStandardsSearch(needle, selectedSubjectFilter, selectedDateFilter);
    }, 1000);

    return () => clearTimeout(handler);
  }, [needle, selectedSubjectFilter, selectedDateFilter]);

  return (
    <div
      css={
        standardsSetMode === STANDARDS_SET_MODE.VIEW ||
        standardsSetMode === STANDARDS_SET_MODE.CREATE
          ? rootViewOrCreateModeCss
          : rootCss
      }
    >
      {renderTitleAndSubtitle()}
      <div css={inputGroupCss}>
        <StandardsModalSearchInput
          isCreateStandardMode
          value={needle}
          onChange={setNeedle}
          disabled={isLoadingStandardsResults}
        />
        <StandardsSetsDropdownFilter
          filterLabel="Filter by Subject"
          filterItems={availableSubjects}
          currentItem={selectedSubjectFilter}
          setItem={setSelectedSubjectFilter}
        />
        <StandardsSetsDropdownFilter
          filterLabel="Filter by Publication Date"
          filterItems={availableDates}
          currentItem={selectedDateFilter}
          setItem={setSelectedDateFilter}
        />
      </div>
    </div>
  );
};
